import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col-md-3" }
const _hoisted_3 = { class: "col-md-9" }
const _hoisted_4 = { class: "table table-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "Sunnies", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Climate zone", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Height", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "Distance", -1)

import { onBeforeMount, ref } from "vue";
import { plantsService } from '@/di/services'
import { Plant, Uuid } from '@/types/api'
import { plantsApi } from '@/di/api'
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";
import AppImageLightBox from "@/components/app/AppImageLightBox.vue";
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";
import PlantSunny from "@/components/plant/PlantSunny.vue";
import PlantMinMax from "@/components/plant/PlantMinMax.vue";

interface Props {
  plantId: Uuid,
  plantName: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlantInfo',
  props: {
    plantId: null,
    plantName: null
  },
  emits: ["update:plantName"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:plantName', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  plantId: Uuid,
  plantName: string,
};

const loadingImage = require.context('@/assets/images/plant', false, /\.jpg/)('./leaf.jpg')





const plant = ref<Plant | null>(null)

const lock = ref<{ plantLoading: boolean }>({ plantLoading: false })

onBeforeMount(async (): Promise<void> => {
  lock.value.plantLoading = true

  try {
    plant.value = await plantsApi.getPlant(props.plantId)

    emit('update:plantName', plant.value.name)
  } finally {
    lock.value.plantLoading = false
  }
})

return (_ctx: any,_cache: any) => {
  return (lock.value.plantLoading)
    ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 0 }, {
        default: _withCtx(() => [
          _createTextVNode("Loading plant info")
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AppImageLightBox, {
            images: _unref(plantsService).buildPlantImageUrls(plant.value),
            alt: plant.value.name,
            "loading-image": _unref(loadingImage)
          }, null, 8, ["images", "alt", "loading-image"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(AppComponentHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(plant.value.latin_name), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(plant.value.description), 1),
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plant.value.sunnies, (sunny, idx) => {
                  return (_openBlock(), _createBlock(PlantSunny, {
                    key: idx,
                    sunny: sunny.value
                  }, null, 8, ["sunny"]))
                }), 128))
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", null, [
                (plant.value.climatic_zones.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(plant.value.climatic_zones.join(', ')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_8,
              _createElementVNode("td", null, [
                (plant.value.height)
                  ? (_openBlock(), _createBlock(PlantMinMax, {
                      key: 0,
                      name: "height",
                      value: plant.value.height
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("td", null, [
                (plant.value.distance)
                  ? (_openBlock(), _createBlock(PlantMinMax, {
                      key: 0,
                      name: "distance",
                      value: plant.value.distance
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
}
}

})